import { useEffect } from "react";

export default function ThemeColorSyncLite() {
  function isMobile() {
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  }
  useEffect(() => {
    if (!isMobile()) return;

    const html = document.documentElement;
    const body = document.body;

    const LIGHT = "#ffffff";
    const DARK = "#1F1F1F";

    let lastColor: string | null = null;
    let rafId: number | null = null;

    const getThemeMeta = () =>
      document.getElementById("theme-color-meta") ||
      document.querySelector('meta[name="theme-color"]');

    const forceSafariRepaint = () => {
      // ترفند: یک transform خیلی کوچک که دیده نمی‌شود
      body.style.transform = "translateZ(0.1px)";
      requestAnimationFrame(() => {
        body.style.transform = "";
      });
    };

    const applyColor = (color: string) => {
      if (lastColor === color) return;
      lastColor = color;

      // ۱) بک‌گراند صفحه
      html.style.backgroundColor = color;
      body.style.backgroundColor = color;

      // ۲) کمی با تأخیر meta را recreate کنیم (برای Safari iOS)
      setTimeout(() => {
        const oldMeta = getThemeMeta();
        if (oldMeta) oldMeta.remove();

        const meta = document.createElement("meta");
        meta.name = "theme-color";
        meta.id = "theme-color-meta";
        meta.content = color;
        document.head.appendChild(meta);

        // ۳) بعد از تغییر meta، Safari را مجبور به repaint کن
        forceSafariRepaint();
      }, 30); // 30ms معمولاً کافی است
    };

    const mql = window.matchMedia("(prefers-color-scheme: dark)");

    const sync = () => {
      const color = mql.matches ? DARK : LIGHT;
      applyColor(color);
    };

    // debounce با requestAnimationFrame
    const debouncedSync = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(sync);
    };

    // مقدار اولیه
    sync();

    // تغییر تم سیستم
    const mediaListener = debouncedSync;
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", mediaListener);
    } else if (typeof mql.addListener === "function") {
      mql.addListener(mediaListener);
    }

    // وقتی کاربر از تنظیمات برمی‌گرده
    const visibilityListener = () => {
      if (!document.hidden) debouncedSync();
    };

    // وقتی Safari صفحه رو دوباره رندر می‌کنه
    const pageShowListener = () => debouncedSync();

    document.addEventListener("visibilitychange", visibilityListener);
    window.addEventListener("pageshow", pageShowListener);

    return () => {
      if (typeof mql.removeEventListener === "function") {
        mql.removeEventListener("change", mediaListener);
      } else if (typeof mql.removeListener === "function") {
        mql.removeListener(mediaListener);
      }

      document.removeEventListener("visibilitychange", visibilityListener);
      window.removeEventListener("pageshow", pageShowListener);

      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return null;
}
